import Vue from 'vue';
import Component from 'vue-class-component';

import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import * as Bluebird from 'bluebird';
import * as _ from 'lodash';
import { NodeObjectModel,Dispatcher,IProductDefinition,ProductDefinitions,NodeObjectRepository } from  '@/models/assembly';





@Component({
  components: {


  },
})
export default class AssemblySteps extends Vue {
  private _configuratorService: ConfiguratorService = undefined;
  private _nodeObjects: NodeObjectModel[] = undefined;
  private _dispatcher: Dispatcher = undefined;
  private _trackedObjects: NodeObjectModel[] = undefined;

  @Prop()
  private definition : IProductDefinition ;

  @Inject()
  private _container: ComponentContainer;

  public currentIndex: number = -1;

  public working: boolean = false;
  public stepIndex: number = 0;

  public get hasNext() {
    return this.definition.steps.length > this.currentIndex + 1 && !this.working;
  }
  public get hasRetry() {
    return this.currentIndex > - 1 && !this.working;
  }

  public get hasPrevious() {
    return this.currentIndex > -1 && !this.working;
  }

  async retry() {
    this._trackedObjects = [];
    this.working = true;
    const stepIndex = this.currentIndex;
    try {
      const repository = new NodeObjectRepository();
      repository.load(...this._nodeObjects);

      this.definition.steps[stepIndex].apply(repository,this._configuratorService);
      this._trackedObjects.push(...repository.trackedObjects);
      const items = this._dispatcher.getAll();
      await Bluebird.mapSeries(items, (promiseFn) => {
        return promiseFn();
      });
    } finally {
      this._dispatcher.reset();
      this.working = false;
      this.currentIndex = stepIndex;
    }
  }

  async nextStep() {
    this._trackedObjects = [];
    this.working = true;
    const stepIndex = this.currentIndex + 1;
    this.stepIndex = stepIndex;
    try {
      const repository = new NodeObjectRepository();
      repository.load(...this._nodeObjects);


      this.definition.steps[stepIndex].apply(repository,this._configuratorService);
      this._trackedObjects.push(...repository.trackedObjects);
      const items = this._dispatcher.getAll();
      await Bluebird.mapSeries(items, (promiseFn) => {
        return promiseFn();
      });
    } finally {
      this._dispatcher.reset();
      this.working = false;
      this.currentIndex = stepIndex;
    }
  }

  async previousStep() {
    this.working = true;
    const stepIndex = this.currentIndex - 1;
    this.stepIndex = stepIndex;
    try {
      // hide previous tracked objects
      _.map(this._trackedObjects, (t) => {
        return t.hide();
      });
      const hideItems = this._dispatcher.getAll();
      await Bluebird.mapSeries(hideItems, (promiseFn) => {
        return promiseFn();
      });
      this._dispatcher.reset();


      const repository = new NodeObjectRepository();
      repository.load(...this._nodeObjects);


      await this.definition.steps[stepIndex].apply(repository, this._configuratorService);
      this._trackedObjects.push(...repository.trackedObjects);
      const items = this._dispatcher.getAll();
      await Bluebird.mapSeries(items, (promiseFn) => {
        return promiseFn();
      });
    } finally {
      this._dispatcher.reset();
      this.working = false;
      this.currentIndex = stepIndex;
    }
  }

  created() {

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    this._configuratorService.hideObjects({
      objects: ['_yyy'],
      operator: FilterOperators.Contains,
    });

    this._dispatcher = new Dispatcher();
    this._trackedObjects = [];
    this._nodeObjects = [];
    _.each(this._configuratorService.nodes, (n) => {
      if (_.includes(n.name, '_yyy') && n.type === 'MatrixTransform') {
        this._nodeObjects.push(new NodeObjectModel(n, this._configuratorService, this._dispatcher));
      }
    });
  }


  mounted() {

  }
}



// WEBPACK FOOTER //
// ./src/components/assembly/AssemblySteps.ts